import { render, staticRenderFns } from "./LearningGroupStudentTableItem.vue?vue&type=template&id=7de23732&"
import script from "./LearningGroupStudentTableItem.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupStudentTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports